import { IACDLEvent } from '../../../services/eventBus.service';

export const WorkspaceDecryptionFailedEventType = Symbol('WORKSPACE_DECRYPTION_FAILED_EVENT');

export class WorkspaceDecryptionFailedEvent implements IACDLEvent {
  readonly type: symbol = WorkspaceDecryptionFailedEventType;
}
